import axios from "axios";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import { useCallback, useContext, useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import { SubscriptionInfo, UserInfo } from "../../../../context";
import _ from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantEmployeeExpense from "./list";
import MerchantEmployeeExpenseConfig from "./config";

const MerchantEmployeeExpenseTab = () => {
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [loading, setLoading] = useState(false);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const navigate = useNavigate();
  const [expenseConfig, setExpenseConfig] = useState({
    data: [],
    ready: false,
  });

  const items = [
    {
      key: "1",
      label: `Expense`,
      children: (
        <MerchantEmployeeExpense
          loading={loading}
          setLoading={setLoading}
          expenseConfig={expenseConfig}
        />
      ),
    },
    {
      key: "2",
      label: `Config`,
      children: (
        <MerchantEmployeeExpenseConfig
          expenseConfig={expenseConfig}
          rerun={() => {
            getExpenseConfig();
          }}
        />
      ),
    },
  ];

  //   const getExpenseList = useCallback(() => {
  //     var params = {
  //       user_id: userData.data.usersmerchantemployee.merchant_user_id,
  //     };
  //     axios
  //       .get("user/merchant/additional-service-list", { params })
  //       .then((response) => {
  //         const data = response.data;
  //         console.log("DATA: ", data);
  //       })
  //       .catch((error) => {
  //         console.log("ERROR: ", error);
  //       });
  //   }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getExpenseConfig = useCallback(() => {
    setLoading(true);
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/get/expense-config", {
        params,
      })
      .then((response) => {
        setLoading(false);
        const data = response.data;
        setExpenseConfig({ data, ready: true });
        // console.log("DATA: ", response.data);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    // getExpenseList();
    getExpenseConfig();
  }, [
    // getExpenseList,
    getExpenseConfig,
  ]);

  return (
    <MerchantEmployeeLayout>
      <Tabs defaultActiveKey="1" items={items} />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeExpenseTab;
